import React from "react";
import { TbArrowLeft, TbArrowRight } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import { Body, Caption1, Title1 } from "../../styles/typography";
import { EVENTS, track } from "../../util/analytics";
import { RequirementTag, STEPS } from "./DetailsWizard";

const PageContainer = styled.div`
  margin: 0 auto;
  margin-top: 90px;
  padding: 24px;
  background: rgb(${(p) => p.theme.colors.white});
  min-height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Description = styled(Body)`
  color: rgb(${(p) => p.theme.colors.neutral400});
`;

const StepList = styled.div`
  border: 2px solid rgb(${(p) => p.theme.colors.neutral150});
  border-radius: 16px;
  overflow: hidden;
`;

const StepRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  &:not(:last-child) {
    border-bottom: 2px solid rgb(${(p) => p.theme.colors.neutral150});
  }
`;

const Note = styled(Caption1)`
  color: rgb(${(p) => p.theme.colors.neutral400});
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;

  button {
    width: fit-content;
  }
`;

const BookOverview = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <ContentWrapper>
        <Heading>
          <Title1 as="h2">Let&apos;s build your book</Title1>
          <Description>
            Next, we&apos;ll walk you through a few questions about your book.
            Your answers give our Design Team a starting point. You can update
            them during the revision rounds, right up until final print
            approval.
          </Description>
        </Heading>

        <StepList>
          {STEPS.map((step) => (
            <StepRow key={step.key}>
              <Body>{step.title}</Body>
              <RequirementTag>
                {step.required ? "Required" : "Optional"}
              </RequirementTag>
            </StepRow>
          ))}
        </StepList>

        <Note>
          Note: The book&apos;s author name defaults to your account name but
          can be changed at any time from the final review page.
        </Note>

        <ButtonRow>
          <Button
            variant="tertiary"
            onButtonClick={() => navigate("/memories")}
          >
            <TbArrowLeft /> Back
          </Button>
          <Button
            variant="primary"
            onButtonClick={() => {
              track(EVENTS.BOOK_WIZARD_STARTED, { stepCount: STEPS.length });
              navigate(`/book/details/${STEPS[0].slug}`);
            }}
          >
            Continue <TbArrowRight />
          </Button>
        </ButtonRow>
      </ContentWrapper>
    </PageContainer>
  );
};

export default BookOverview;
